import { Injectable, isDevMode } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './toaster/toaster.service';

@Injectable({
    providedIn: 'root',
})
export class SessionstorageService  {

    constructor() {
    }

    retrieve(key: string): any {
        let item = sessionStorage.getItem(key);
        if (item && item !== 'undefined') {
            return JSON.parse(sessionStorage.getItem(key));
        }
        return;
    }

    store(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

}
